/* global $, currentScore, FB, loadImage, toastr, tranEv */

toastr.options.progressBar = true;

const onScroll = function () {};

const onResize = function () {
  onScroll();
};

const onLoad = function () {
  if ($('.scoreSvg').length > 0) {
    const dashArrayVal = 600 - (currentScore * 60);

    $('.scoreSvg .score-2').css({
      'stroke-dashoffset': dashArrayVal,
    });

    $('.scoreSvg').addClass('move');
  }

  if ($('.intro-slider').length > 0) {
    $('.intro-slider').owlCarousel({
      items: 1,
      loop: false,
      nav: false,
      dots: true,
      autoHeight: true,
      smartSpeed: 700,
    });
  }

  if ($('.tops .lists').length > 0) {
    $('.tops .lists').owlCarousel({
      items: 1,
      loop: false,
      nav: false,
      dots: false,
      mouseDrag: false,
      touchDrag: false,
      pullDrag: false,
      freeDrag: false,
      autoHeight: true,
    });
  }
  if ($('.infos-sect .infos').length > 0) {
    $('.infos-sect .infos').owlCarousel({
      items: 1,
      loop: false,
      nav: false,
      dots: false,
      mouseDrag: false,
      touchDrag: false,
      pullDrag: false,
      freeDrag: false,
      autoHeight: true,
    });
  }

  onResize();
};

const closeSelect = function (select) {
  select.find('.options-list').removeClass('filtering').scrollTop(0);
  select.find('.options-list .option').removeClass('show fakeFocus');
  select.find('#search-input').val('');
  select.find('#search-input').blur('');
  select.find('.fakeToggle').removeClass('active');
  select.find('.fakeDrop').removeClass('top');
};

const showMoreFields = function (select, kilmininkas) {
  const form = select.closest('form');
  const toshow = form.find('.toShow');
  const value = select.find('select').val();

  if (value !== '') {
    toshow.find('label span').text(kilmininkas);
    toshow.addClass('showing').slideDown(300);
  } else {
    toshow.find('label span').text('');
    toshow.removeClass('showing').slideUp(300);
  }
};

const showTooltips = function () {
  const isMobSafari = !!navigator.userAgent.match(/Version\/[\d.]+.*Safari/);
  const isMobChrome = navigator.userAgent.match('CriOS');

  if (isMobSafari) {
    $('.tooltip.safari').animateCssFlexShow('bounceInDown', () => {
      $('body').on('click', () => {
        $('.tooltip.safari').animateCssHide('bounceOutUp');
      });
    });
  } else if (isMobChrome) {
    $('.tooltip.chrome').animateCssFlexShow('bounceInUp', () => {
      $('body').on('click', () => {
        $('.tooltip.chrome').animateCssHide('bounceOutDown');
      });
    });
  }
};

const otherSlider = function () {
  $('.intro-slider').animateCss('slideOutLeft', () => {
    $('.intro-slider').addClass('hide');
  });

  showTooltips();
};

$(window).on('scroll', onScroll);
$(window).on('resize', onResize);
$(window).on('load', onLoad);

$('textarea, input').on('change keyup keydown keypress', function () {
  if (this.value.trim().length > 0) {
    $(this).closest('.input, .upload-card').addClass('full');
    $(this).removeClass('wpcf7-not-valid').closest('.input, .upload-card').removeClass('error');
    if ($(this).closest('form').find('.error').length !== 0) {
      $(this).closest('form').find('.error-message').slideDown();
    }
  } else {
    $(this).closest('.input, .file-div').removeClass('full');
  }
});

$(document).on('change', 'select', function () {
  $(this).closest('.select').removeClass('error');
  if ($(this).closest('form').find('.error').length === 0) {
    $(this).closest('form').find('.error-message').slideUp();
  }
});

$('textarea, input').on('focusin', function () {
  $(this).closest('.input').addClass('focus');
});

$('textarea, input').on('focusout', function () {
  $(this).closest('.input').removeClass('focus');
});

$('body').on('click', '[href^="#"]', function (e) {
  e.preventDefault();
  const href = $(this).attr('href');
  let modal = null;

  if (href === '#rules') {
    modal = $('.modal.rules');
  }

  if (href === '#letsgo') {
    otherSlider();
  }

  if (href === '#changemail') {
    modal = $('.modal.changeMail');
  }

  if (href === '#submitIntroMail') {
    if ($('.changeMail input')[0].value.trim().length > 0) {
      if ($('.changeMail input')[0].checkValidity()) {
        $('.intro-email-changeVal').val($('.changeMail input')[0].value);
        $('.intro-email-changeText').text($('.changeMail input')[0].value);
        $('.changeMail').animateCssHide('fadeOut');
        $('body').removeClass('fixed');
      } else {
        $('.changeMail input').animateCss('shake');
      }
    } else {
      $('.changeMail input').animateCss('shake');
    }
  }

  if (modal != null) {
    if (!modal.hasClass('animated')) {
      $('body').addClass('fixed');
      modal.animateCssShow('fadeIn');
    }
  }

  return false;
});

$('body').on('click', '.modal', function (e) {
  if (!$(this).hasClass('animated')) {
    const targetClose = $(e.target).is('.close') || $(e.target).closest('.close').length > 0;

    if (targetClose) {
      $(this).animateCssHide('fadeOut');
      $(this).removeClass('active');
      $('body').removeClass('fixed');
    }
  }
});

$('.select.search #search-input').on('keyup keydown change', function (e) {
  const searchBy = this.value.trim().toLowerCase();

  if (!(e.keyCode === 27 || e.keyCode === 13 || e.keyCode === 38 || e.keyCode === 40)) {
    $(this).closest('.fakeDrop').find('.option').removeClass('show fakeFocus');

    if (searchBy.length > 0) {
      $(this).closest('.fakeDrop').find('.options-list').addClass('filtering');
      $(this).closest('.fakeDrop').find('.options-list .option').filter(function () {
        return ($(this).text().toLowerCase().indexOf(searchBy) > -1);
      })
        .addClass('show');
    } else {
      $(this).closest('.fakeDrop').find('.options-list').removeClass('filtering');
    }
  }
});

$('.select .fakeDrop .options-list').on('mousemove', function () {
  $(this).find('.fakeFocus').removeClass('fakeFocus');
});

$('body').on('click', '.select .fakeDrop .option', function () {
  const thisValue = $(this).data('value');
  const thisKilmininkas = $(this).data('kilmininkas');
  const $this = $(this).closest('.select');
  $this.find('select').val(thisValue);
  $this.find('select').trigger('change');
  $this.find('.fakeToggle p').text($(this).text());

  if ($this.hasClass('showMore')) {
    showMoreFields($this, thisKilmininkas);
  }

  closeSelect($this);
});

$('body').on('click', '.select .fakeToggle', function () {
  $(this).toggleClass('active');
  if ($(this).hasClass('active')) {
    $(this).closest('.select').find('#search-input').focus();

    if ($(this).siblings('.fakeDrop')[0].getBoundingClientRect().bottom > $(this).closest('form')[0].getBoundingClientRect().bottom) {
      $(this).siblings('.fakeDrop').addClass('top');
    }
  }
});

let elemTop;
let height;
let thisValue;
let thisKilmininkas;

if ($('.select').length > 0) {
  $(document).on('click', (e) => {
    const $this = $('.select .fakeToggle.active').closest('.select');
    if ($this.length > 0) {
      const target = !($(e.target).is('.select') || $(e.target).closest('.select').length > 0);
      if (target) {
        closeSelect($this);
      }
    }
  });
  $(document).on('keyup', function (e) {
    const $this = $('.select .fakeToggle.active').closest('.select');

    if ($('.select .fakeToggle.active').length > 0) {
      if (e.keyCode === 27) {
        // ESC
        if ($('.select').length > 0) {
          closeSelect($('.select'));
        }
      } else if (e.keyCode === 38) {
        // Up
        if ($this.find('.options-list').hasClass('filtering')) {
          if ($this.find('.options-list .show.fakeFocus').length > 0) {
            if ($this.find('.options-list .show.fakeFocus').prevAll('.show').first().length > 0) {
              $this.find('.options-list .show.fakeFocus').removeClass('fakeFocus').prevAll('.show').first()
                .addClass('fakeFocus');
            }
          } else {
            $this.find('.options-list .show').first().addClass('fakeFocus');
          }
        } else if ($this.find('.options-list .option.fakeFocus').length > 0) {
          if ($this.find('.options-list .option.fakeFocus').prev('.option').last().length > 0) {
            $this.find('.options-list .option.fakeFocus').removeClass('fakeFocus').prev('.option').last()
              .addClass('fakeFocus');
          }
        } else {
          $this.find('.options-list .option').first().addClass('fakeFocus');
        }

        elemTop = $this.find('.options-list .fakeFocus').offset().top - $this.find('.options-list').offset().top + $this.find('.options-list').scrollTop();
        height = parseInt($this.find('.options-list').css('height'), 10) - 30;

        $this.find('.options-list').scrollTop(elemTop - height);
      } else if (e.keyCode === 40) {
        // Down
        if ($this.find('.options-list').hasClass('filtering')) {
          if ($this.find('.options-list .show.fakeFocus').length > 0) {
            if ($this.find('.options-list .show.fakeFocus').nextAll('.show').first().length > 0) {
              $this.find('.options-list .show.fakeFocus').removeClass('fakeFocus').nextAll('.show').first()
                .addClass('fakeFocus');
            }
          } else {
            $this.find('.options-list .show').first().addClass('fakeFocus');
          }
        } else if ($this.find('.options-list .option.fakeFocus').length > 0) {
          if ($this.find('.options-list .option.fakeFocus').next('.option').length > 0) {
            $this.find('.options-list .option.fakeFocus').removeClass('fakeFocus').next('.option').addClass('fakeFocus');
          }
        } else {
          $this.find('.options-list .option').first().addClass('fakeFocus');
        }

        elemTop = $this.find('.options-list .fakeFocus').offset().top - $this.find('.options-list').offset().top + $this.find('.options-list').scrollTop();
        height = parseInt($this.find('.options-list').css('height'), 10) - 30;

        $this.find('.options-list').scrollTop(elemTop - height);
      } else if (e.keyCode === 13) {
        // Enter
        const searchBy = $this.find('#search-input')[0].value.trim().toLowerCase();
        if ($this.find('.fakeFocus').length > 0) {
          thisValue = $this.find('.fakeFocus').data('value');
          thisKilmininkas = $this.find('.fakeFocus').data('kilmininkas');
          $this.find('select').val(thisValue);
          $this.find('select').trigger('change');
          $this.find('.fakeToggle p').text($this.find('.fakeFocus').text());

          if ($this.hasClass('showMore')) {
            showMoreFields($this, thisKilmininkas);
          }
        } else if (searchBy.length > 0) {
          if ($this.find('.options-list .option.show').length > 0) {
            thisValue = $this.find('.options-list .option.show').first().data('value');
            thisKilmininkas = $this.find('.options-list .option.show').first().data('kilmininkas');
            $this.find('select').val(thisValue);
            $this.find('select').trigger('change');
            $this.find('.fakeToggle p').text($this.find('.options-list .option.show').first().text());

            if ($this.hasClass('showMore')) {
              showMoreFields($this, thisKilmininkas);
            }
          } else {
            $this.find('.fakeToggle p').text($(this).closest('.select').find('fakeToggle').data('placeholder'));
          }
        } else {
          $this.find('.fakeToggle p').text($(this).closest('.select').find('fakeToggle').data('placeholder'));
        }

        closeSelect($this);
      }
    }
  });
}

$('body').on('click', '.question .trigger', function () {
  const $answer = $(this).closest('.question').find('.answer');
  $answer.css({ height: parseInt($answer.find('.wysiwyg').css('height'), 10) });

  $(this).closest('.question').toggleClass('active').one(tranEv, () => {
    $('.infos-sect .infos').trigger('refresh.owl.carousel');
  });
  $(this).closest('.question').siblings('.question.active').removeClass('active');
});

$('body').on('click', '.tops .tab', function () {
  $(this).addClass('active').siblings('.active').removeClass('active');
  if ($(this).data('id') === 'draugu') {
    $('.tops .lists').trigger('to.owl.carousel', [1, 350]);
  } else {
    $('.tops .lists').trigger('to.owl.carousel', [0, 350]);
  }
});

$('body').on('click', '.infos-sect .tab', function () {
  $(this).addClass('active').siblings('.active').removeClass('active');

  if ($(this).data('id') === 'privacy') {
    $('.infos-sect .infos').trigger('to.owl.carousel', [0, 350]);
  } else if ($(this).data('id') === 'rules') {
    $('.infos-sect .infos').trigger('to.owl.carousel', [1, 350]);
  } else if ($(this).data('id') === 'faqs') {
    $('.infos-sect .infos').trigger('to.owl.carousel', [2, 350]);
  } else {
    $('.infos-sect .infos').trigger('to.owl.carousel', [3, 350]);
  }
});

$('.upload-card input').on('change', function (event) {
  const uploadCard = $(this).closest('.upload-card');
  const uploaded = uploadCard.find('.uploaded');
  const stage = uploaded.find('.stage');
  const ValidImageTypes = ['image/gif', 'image/jpeg', 'image/png'];
  const input = this;

  if (input.files && input.files[0]) {
    const fileType = input.files[0].type;
    if ($.inArray(fileType, ValidImageTypes) < 0) {
      $('body').addClass('fixed');
      $('.error-file-upload').animateCssShow('fadeIn');

      uploaded.attr('class', 'uploaded');
      uploaded.animateCssHide('fadeOut', () => {
        stage.html('');
      });
    } else {
      const { originalEvent } = event;
      const target = originalEvent.dataTransfer || originalEvent.target;
      const file = target && target.files && target.files[0];
      const options = {
        maxWidth: parseInt(uploadCard.css('width'), 10),
        maxHeight: parseInt(uploadCard.css('height'), 10),
        canvas: true,
        cover: true,
        pixelRatio: window.devicePixelRatio,
        downsamplingRatio: 0.5,
        orientation: true,
      };

      loadImage(file, (img) => {
        const currentFile = file;
        // let fileName = currentFile.name;
        let href = img.src;
        let dataURLStart;

        if (img.src || img instanceof HTMLCanvasElement) {
          if (!href) {
            href = img.toDataURL(`${currentFile.type}REMOVEME`);
            dataURLStart = `data:${currentFile.type}`;
            if (href.slice(0, dataURLStart.length) !== dataURLStart) {
              // fileName = fileName.replace(/\.\w+$/, '.png');
            }
          }
        }

        uploaded.attr('class', 'uploaded');
        stage.append(img);
        uploaded.animateCssFlexShow('fadeIn');
      }, options);
    }
  } else {
    uploaded.attr('class', 'uploaded');
    uploaded.animateCssHide('fadeOut', () => {
      stage.html('');
    });
  }
});

$('body').on('click', '.upload-card .uploaded .remove', () => {
  $('.upload-card input').val('');
  $('.upload-card input').trigger('change');
});


$('.upload-form').on('submit', function (e) {
  const toCheck = $(this).find('.input input, .select select, .upload-card input');

  for (let i = 0; i < toCheck.length; i += 1) {
    const $this = toCheck.eq(i);
    if ($this[0].value.trim().length < 1) {
      if ($this.closest('.input, .select, .upload-card').hasClass('toShow')) {
        if ($this.closest('.input, .select, .upload-card').hasClass('showing')) {
          $this.closest('.input, .select, .upload-card').addClass('error');
        }
      } else {
        $this.closest('.input, .select, .upload-card').addClass('error');
      }
    }
  }

  if ($(this).find('.error').length > 0) {
    e.preventDefault();
    $('.error-message').slideDown();
    return false;
  }

  $('.error-message').slideUp();
  return true;
});

$('.button.urls:not(.disabled)').on('click', function () {
  const button = $(this);

  if (!button.hasClass('clicked')) {
    $.ajax({
      url: '/promotion/generate',
      type: 'GET',
      beforeSend() {
        button.addClass('clicked');
      },
      success(data, status) {
        if (status === 'success') {
          $('body').addClass('fixed');
          $('.return-url #urlout').val(data.slice(12));
          $('.return-url').animateCssShow('fadeIn');
          button.removeClass('clicked');
        } else {
          button.addClass('disabled');
          button.find('small').html($('#js-promo-error').data('promo-error'));
          button.removeClass('clicked');
        }
      },
      error() {
        button.addClass('disabled');
        button.find('small').html($('#js-promo-error').data('promo-error'));
        button.removeClass('clicked');
      },
      fail() {
        button.addClass('disabled');
        button.find('small').html($('#js-promo-error').data('promo-error'));
        button.removeClass('clicked');
      },
    });
  }
});


// GLOBAL MENU

$('#menuBurger').on('click', () => {
  $('#menuActive').removeClass('hidden');
});

$('#closeMenu').on('click', () => {
  $('#menuActive').addClass('hidden');
});

$('#menuUser').on('click', () => {
  $('#menuUserDropdown').toggleClass('hidden');
});


if ($('main').hasClass('home-page')) {
  $('.header').addClass('home');
  $('.main-container').addClass('yellow');
} else {
  $('.header').removeClass('home');
  $('.main-container').removeClass('yellow');
}

// CAROUSEL
$('.movies-list').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        dots: false,
      },
    },
  ],
});

$('.posts-list').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
      },
    },
  ],
});

// CUSTOM LOCAL SELECT

$('.js-custom-locale-select').each(function (index, el) {
  const $this = $(this);
  const numberOfOptions = $(this).children('option').length;

  $this.addClass('custom-select-hidden');
  $this.wrap('<div class="custom-select"></div>');
  $this.after('<div class="custom-select-styled"></div>');

  const $styledSelect = $this.next('div.custom-select-styled');
  $styledSelect.text($this.children('option[selected="selected"]').eq(0).text());

  const $list = $('<ul />', {
    class: 'custom-select-options',
  }).insertAfter($styledSelect);

  for (let i = 0; i < numberOfOptions; i += 1) {
    $('<li />', {
      text: $this.children('option').eq(i).text(),
      rel: $this.children('option').eq(i).val(),
    }).appendTo($list);
  }

  const $listItems = $list.children('li');

  $styledSelect.click(function (e) {
    e.stopPropagation();
    $('div.custom-select-styled.active').not(this).each(function () {
      $(this).removeClass('active').next('ul.custom-select-options').hide();
    });
    $(this).toggleClass('active').next('ul.custom-select-options').toggle();
  });

  $listItems.click(function (e) {
    e.stopPropagation();
    $styledSelect.text($(this).text()).removeClass('active');
    $(el).val($(this).attr('rel'));
    $('.js-form-locale').submit();
    $list.hide();
  });

  $(document).click(() => {
    $styledSelect.removeClass('active');
    $list.hide();
  });
});

$('.js-movie').click(function () {
  const $movie = $(this);
  const $modalMovieShow = $('.js-modal-movie-show');

  $modalMovieShow
    .find('.js-modal-movie-show__title')
    .text($movie.attr('data-title'));

  $modalMovieShow
    .find('.js-modal-movie-show__platform')
    .text($movie.attr('data-platform'));

  $modalMovieShow
    .find('.js-modal-movie-show__is-recommended')
    .text($movie.attr('data-is-recommended'));

  $modalMovieShow
    .find(`.js-modal-movie-show__rating input[value="${$movie.attr('data-rating')}"]`)
    .prop('checked', true);

  $modalMovieShow
    .find('.js-modal-movie-show__image')
    .attr(
      'style',
      $movie.find('.js-movie__image').attr('style'),
    );

  $modalMovieShow
    .find('.js-modal-movie-show__delete-1')
    .attr(
      'data-id',
      $movie.attr('data-id'),
    );

  $('body').addClass('fixed');
  $movie.addClass('js-movie--selected');
  $modalMovieShow.addClass('active');
});

$('.js-modal-movie-show__close').click(() => {
  $('.js-modal-movie-show').removeClass('active');
  $('.js-movie').removeClass('js-movie--selected');
  $('body').removeClass('fixed');
});

$('.js-modal-movie-close__delete-2').click(() => {
  $('.areYouSure').css('display', 'none');
});

$('.js-modal-movie-show__delete-1').click(() => {
  const $deleteMovieModal = $('.js-modal-movie-delete');

  if (!$deleteMovieModal.hasClass('animated')) {
    const $selectedMovie = $('.js-movie--selected');

    $deleteMovieModal
      .find('.js-modal-movie-delete__title')
      .text($selectedMovie.attr('data-title'));

    $deleteMovieModal
      .find('.js-modal-movie-delete__platform')
      .text($selectedMovie.attr('data-platform'));

    $deleteMovieModal
      .find('.js-modal-movie-delete__image')
      .attr(
        'style',
        $selectedMovie.find('.js-movie__image').attr('style'),
      );

    $deleteMovieModal.animateCssShow('fadeIn');
  }
});

$('.js-modal-movie-show__delete-2').click(() => {
  const $selectedMovie = $('.js-movie--selected');

  $.ajax({
    url: `${window.origin}/api/user/movie/${$selectedMovie.attr('data-id')}`,
    type: 'DELETE',
    success() {
      $selectedMovie.animateCssHide('zoomOut', () => {
        $selectedMovie.remove();
        $('.inner-hero h1 span').text((parseInt($('.inner-hero h1 span').text(), 10) - 1));
      });

      $('.js-modal-movie-delete').animateCssHide('fadeOut');
      $('.js-modal-movie-show').removeClass('active');
      $('body').removeClass('fixed');
    },
    error(error) {
      console.error('Delete movie error', error);
      toastr.error(error.responseText);
      $('.js-modal-movie-delete').animateCssHide('fadeOut');
    },
  });
});

$('.js-modal-movie-show__share-facebook').click(() => {
  const facebookClientId = window.appBackendData
    ? window.appBackendData.facebookClientId
    : null;

  if (!facebookClientId) {
    return;
  }

  const $selectedMovie = $('.js-movie--selected');

  FB.ui({
    method: 'share_open_graph',
    action_type: 'og.shares',
    action_properties: JSON.stringify({
      object: {
        id: facebookClientId,
        url: window.location.origin,
        description: `${$selectedMovie.attr('data-title')}, Director: ${$selectedMovie.attr('data-director')}, Watched At: ${$selectedMovie.attr('data-where')}`,
        title: '#EuropeanFilmChallenge',
        image: $selectedMovie.attr('data-image'),
        'og:image:width': 1200,
        'og:image:height': 630,
      },
    }),
  }, (response) => {
    if (response && !response.error_message) {
      // console.log('success');
    } else {
      console.error('Facebook error', response ? response.error_message : null);
    }
  });
});
